/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Progress_Extra_Totals_VsInputs */

const en_us2_progress_extra_totals_vs = /** @type {(inputs: Progress_Extra_Totals_VsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arrows: against the same stretch of last month`)
};

const pt_br2_progress_extra_totals_vs = /** @type {(inputs: Progress_Extra_Totals_VsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Setas: contra o mesmo trecho do mês passado`)
};

const es_419_progress_extra_totals_vs = /** @type {(inputs: Progress_Extra_Totals_VsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flechas: frente al mismo tramo del mes pasado`)
};

const pt_pt2_progress_extra_totals_vs = /** @type {(inputs: Progress_Extra_Totals_VsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Setas: face ao mesmo período do mês passado`)
};

const fr_fr2_progress_extra_totals_vs = /** @type {(inputs: Progress_Extra_Totals_VsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flèches : par rapport à la même période du mois dernier`)
};

const de_de2_progress_extra_totals_vs = /** @type {(inputs: Progress_Extra_Totals_VsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pfeile: im Vergleich zum gleichen Zeitraum im Vormonat`)
};

const it_it2_progress_extra_totals_vs = /** @type {(inputs: Progress_Extra_Totals_VsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frecce: rispetto allo stesso periodo del mese scorso`)
};

/**
* | output |
* | --- |
* | "Arrows: against the same stretch of last month" |
*
* @param {Progress_Extra_Totals_VsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_extra_totals_vs = /** @type {((inputs?: Progress_Extra_Totals_VsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Extra_Totals_VsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_extra_totals_vs(inputs)
	if (locale === "es-419") return es_419_progress_extra_totals_vs(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_extra_totals_vs(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_extra_totals_vs(inputs)
	if (locale === "de-DE") return de_de2_progress_extra_totals_vs(inputs)
	if (locale === "it-IT") return it_it2_progress_extra_totals_vs(inputs)
	return en_us2_progress_extra_totals_vs(inputs)
});
export { progress_extra_totals_vs as "progress-extra.totals_vs" }